var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-none text-lg text-right px-3 py-2"},[_c('ub-button',{attrs:{"size":"sm","variant":"secondary","icon":_vm.collapsedIcon,"outline":""},on:{"click":_vm.increment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }